/**
 *  ######################################
 *  ### DO NOT EDIT THIS FILE DIRECTLY ###
 *  ######################################
 *
 * This file is generated from:
 * /crates/mgo-open-rpc/spec/openrpc.json
 */

import type { GetReferenceGasPriceParams } from '@mgonetwork/mango.js/client';

import type { UseMgoClientQueryOptions } from '../useMgoClientQuery.js';
import { useMgoClientQuery } from '../useMgoClientQuery.js';

export function useReferenceGasPrice(
	params: GetReferenceGasPriceParams = {},
	options?: UseMgoClientQueryOptions<'getReferenceGasPrice'>,
) {
	return useMgoClientQuery(
		{
			method: 'getReferenceGasPrice',
			params,
		},
		options,
	);
}
